import React, { useEffect, useMemo, useState } from 'react'

const ExploreCaousels = (props) => {
    const slides = useMemo(() => [props.imgA, props.imgB, props.imgC].filter(Boolean), [props.imgA, props.imgB, props.imgC])
    const [activeIndex, setActiveIndex] = useState(0)

    useEffect(() => {
        if (slides.length <= 1) return undefined

        const timer = window.setInterval(() => {
            setActiveIndex((index) => (index + 1) % slides.length)
        }, Number(props.timer) || 3000)

        return () => window.clearInterval(timer)
    }, [slides.length, props.timer])

    return (
        <div className='explore-carousel-inner relative overflow-hidden'>
            {slides.map((slide, index) => (
                <img
                    key={`${slide}-${index}`}
                    src={slide}
                    className={`explore-carousel-img absolute inset-0 transition-opacity duration-700 ${index === activeIndex ? 'opacity-100' : 'opacity-0'}`}
                    alt='Tour Spots'
                />
            ))}
        </div>
    )
}

export default ExploreCaousels
